import api from '@motionelements/core/src/api/base-api-v2';

export const createFreeElementsInvite = async (payload, axiosConfig) => {
  const request = await api.request('post', '/v2/free-elements/invite', {
    ...(axiosConfig || {}), // for recaptcha headers
    data: payload,
  });
  return request;
};

export const createShareUrl = async () => {
  const request = await api.request('post', '/v2/free-elements/share');
  return request;
};

export const getPartner = async (id) => {
  const request = await api.get(`/v2/free-elements/partners/${id}`, {
    params: api.getLocaleParams(),
  });
  return request;
};

export const listCurations = async (params) => api.get('/v2/curations', {
  params: {
    ...api.getLocaleParams(),
    ...params,
  },
});
